export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_42-6cb39b436ec1d4a451a96fc675f2f9e6.jpg";